
const filterId = {
    DATE: 'date',
    VENDOR: 'vendor',
    ACCOUNT_MANAGER: 'account_manager',
    STATUS: 'status',
    PRICE: 'price',
    BUDGET: 'budget_id',
    IS_PBD: 'is_pbd',
    DEAL_STATUS: 'deal_status_id'
};

export default filterId;